/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PostEscalationTicketCommentRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {PostEscalationTicketCommentResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const postEscalationTicketComment = (request: PostEscalationTicketCommentRequest, options?: CashRequestOptions) => post<PostEscalationTicketCommentRequest, PostEscalationTicketCommentResponse>("/2.0/cash/post-escalation-ticket-comment", request, {...options, rejectOnError: true })